export default {
  data() {
    return {
      rollen: [],
      permissions: []
    }
  },
  methods: {
    rollenAbrufen() {
      this.$$abrufen('roles').then(response => {
        this.rollen = response.rollen;
        this.permissions = response.permissions;
      });
    },
  },
  mounted() {
    // this.rollenAbrufen();
  }
}
